<template>
  <aside
    class="relative bg-app-light h-screen w-64 hidden sm:block shadow-xl overflow-y-scroll"
  >
    <div class="pl-6 pr-6 pt-6">
      <router-link
        to="/"
        class="text-white text-3xl font-semibold uppercase hover:text-gray-300"
        >Admin</router-link
      >
    </div>
    <nav class="text-white text-base font-semibold pt-3">
      <div
        v-for="(menu, index) in menuList"
        :key="menu.title"
        class="flex items-center text-white hover:bg-app-default py-3 pl-6 nav-item cursor-pointer"
        :class="{ 'bg-app-default': menu.link === active }"
        @click="selectItem(index, menu.link)"
      >
        <fas :icon="menu.icon" class="mr-3" />
        {{ menu.title }}
      </div>
    </nav>
  </aside>
</template>

<script>
export default {
  name: "SideBar",
  data() {
    return {
      menuList: [
        {
          title: "Company",
          icon: "building",
          link: `/`,
        },
        {
          title: "Users",
          icon: "users",
          link: `/users`,
        },
        {
          title: "Carousel",
          icon: "credit-card",
          link: `/carousel`,
        },
        {
          title: "Profile",
          icon: "user",
          link: `/profile`,
        },
        {
          title: "Category Tenant",
          icon: "code-branch",
          link: `/tenant-category`,
        },
        {
          title: "Category Promo",
          icon: "code-branch",
          link: `/promo-category`,
        },
        {
          title: "Tenant",
          icon: "users",
          link: `/tenant`,
        },
        {
          title: "Promo",
          icon: "percent",
          link: `/promo`,
        },
        {
          title: "Destination",
          icon: "percent",
          link: `/destination`,
        },
        {
          title: "Destination Premium",
          icon: "percent",
          link: `/destinationpremium`,
        },
        {
          title: "Event",
          icon: "sticky-note",
          link: `/event`,
        },
        {
          title: "Event Premium",
          icon: "sticky-note",
          link: `/event-premium`,
        },
        {
          title: "Facility",
          icon: "restroom",
          link: `/faciliti`,
        },
        {
          title: "Sosmed",
          icon: "thumbs-up",
          link: `/sosmed`,
        },
        {
          title: "Subscriber",
          icon: "chart-bar",
          link: `/subscriber`,
        },
        {
          title: "Floor",
          icon: "th",
          link: `/floor`,
        },
        {
          title: "Home",
          icon: "newspaper",
          link: `/information`,
        },
        {
          title: "Experience",
          icon: "tachometer-alt",
          link: `/experience`,
        },
        {
          title: "Seo",
          icon: "globe-americas",
          link: `/seo`,
        },
      ],
      active: `/`,
    };
  },
  beforeMount: async function() {
    let arrPath = this.$route.path.split("/");
    // let originpath = `/${arrPath[1]}/${arrPath[2]}`;
    let originpath = `/${arrPath[1]}`;
    this.active = originpath;
  },
  created: function() {
    if (!this.$store.state.isAdmin) {
      this.menuList = this.menuList.filter((item) => item.link !== "/users");
    }
  },
  methods: {
    selectItem(i, link) {
      if (this.$route.path !== link) {
        this.$router.push(link);
      }
      this.active = link;
    },
  },
};
</script>
